<div class="container-fluid px-4" style="max-width: 1600px;">
  <!-- Registration Flow Header -->
  @if (isFromRegistrationFlow) {
    <div class="cyber-scan-header-spectacular">
      <div class="cyber-header-icon">
        <i class="fas fa-layer-group"></i>
      </div>
      <div>
        <h2 class="h3 mb-1">Choose Your Plan</h2>
        <p class="text-muted mb-0">Select the plan that best fits your needs. All paid plans include full feature access.</p>
      </div>
    </div>

    <!-- Progress Indicator for Registration Flow -->
    <div class="progress-indicator mb-4">
      <div class="progress">
        <div class="progress-bar bg-cyber-accent" role="progressbar"
          aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"
          aria-label="Registration progress: Step 4 of 4 complete">
          <span class="visually-hidden">90% Complete</span>
        </div>
      </div>
      <small class="text-muted">Step 4 of 4 — Almost done!</small>
    </div>
  }

  <!-- Validation Warning -->
  @if (showValidationWarning && isFromRegistrationFlow) {
    <div class="cyber-alert cyber-alert-warning mb-4">
      <div class="d-flex">
        <i class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"></i>
        <div>
          <h6 class="cyber-alert-heading">Complete Required Information</h6>
          <p class="mb-2">
            Please complete the following before selecting a plan:
          </p>
          <ul class="mb-0">
            @for (requirement of missingRequirements; track requirement) {
              <li>
                {{ requirement }}
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  }
  <app-select-plan-partial [showCompanyBased]="true" [isRegistrationFlow]="isFromRegistrationFlow"></app-select-plan-partial>
</div>
